import * as React from 'react'
import { enableMapSet } from 'immer'
import { Provider } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import { Route, Routes } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'

import 'react-toastify/dist/ReactToastify.css'

import StyledEngineProvider from '@mui/material/StyledEngineProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'

import { App } from './components/App'
import { store } from '@user/store/store'
import { Modal } from '@user/components/Modal'
import { ErrorBoundary } from '@sales-center/components'
import { createHereCrud } from '@user/store/services/hereGeoCoder'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { SalesCenterThemeProvider } from './SalesCenterThemeProvider'
import { I18nextProvider } from 'react-i18next'
import i18n from '../i18n'
import { SCGlobalStyles } from '@sales-center/common'
import { registerTidal } from '@workwave-tidal/license'
import { SCSnackMachine } from '@sales-center/components'

enableMapSet()

export const { getPlaceAddress, queryPlaces, geocode } = createHereCrud()

const clientQuery = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      staleTime: 60000,
    },
  },
})

registerTidal({
  product: 'sales-center/user',
})

export const Root: React.FC = () => {
  return (
    <>
      {SCGlobalStyles}

      <ToastContainer
        stacked
        position="top-center"
        style={{
          zIndex: 999999, // higher than any MUI dialog / backdrop
          pointerEvents: 'auto', // ensure clickable
        }}
      />
      <StyledEngineProvider injectFirst>
        <SalesCenterThemeProvider>
          <I18nextProvider i18n={i18n}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Provider store={store}>
                <QueryClientProvider client={clientQuery}>
                  <Modal />
                  <ErrorBoundary>
                    <Routes>
                      <Route path="/*" element={<App />} />
                    </Routes>
                  </ErrorBoundary>
                </QueryClientProvider>
              </Provider>
            </LocalizationProvider>
          </I18nextProvider>
          <SCSnackMachine />
        </SalesCenterThemeProvider>
      </StyledEngineProvider>
    </>
  )
}
Root.displayName = 'Root'

export default Root
